import { render } from "./CommissioningPage.vue?vue&type=template&id=1e5566cc&ts=true"
import script from "./CommissioningPage.vue?vue&type=script&lang=ts"
export * from "./CommissioningPage.vue?vue&type=script&lang=ts"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__